import {connect} from 'react-redux';
import MyListings from '../components/my-listings/my-listings';

const mapStateToProps = (state) => {
  return {
    entity: state.store.entity,
    defaultOptions: state.store.defaultOptions
  };
};

export default connect(mapStateToProps)(MyListings);



// WEBPACK FOOTER //
// ./src/containers/my-listings.js